<div class="page-container">
<mat-card class="card-wrapper">
    <mat-card-header class="header-terms-and-conditions">
        <mat-card-title>
            <label class="icon terms_and_conditions">
                <prl-label value='label.terms.and.conditions'/>
            </label>
        </mat-card-title>
    </mat-card-header>

    <mat-card-content class="content-terms-and-conditions" [innerHTML]="contentHtml | mxSafeHtml"/>

    @if (authService.token && isTcNotAccepted()) {
        <mat-checkbox class="mxs-checkbox" [(ngModel)]="tcCheckbox" required>
            <prl-label value='label.signup.agree.to.terms'/>
        </mat-checkbox>
        <mat-card-actions class="actions-terms-and-conditions">
            <mx-button [buttonModel]="submitButton"></mx-button>
        </mat-card-actions>
    }
</mat-card>
</div>
